export const colorMap = {
  'devui-text': 'var(--theme-text)',
  'devui-aide-text': 'var(--theme-aide-text)',
  'devui-placeholder': 'var(--theme-placeholder)',
  'devui-disabled-text': 'var(--theme-disable-text)',
  'devui-light-text': 'var(--theme-light-text)',
  'devui-icon-fill': 'var(--theme-icon-fill)',
  'devui-icon-fill-weak': 'var(--theme-icon-fill-weak)',
  'devui-icon-fill-hover': 'var(--theme-icon-fill-hover)',
  'devui-icon-disabled-color': 'var(--theme-icon-disabled-color)',
  'devui-icon-bg': 'var(--theme-icon-bg)',
  'devui-brand': 'var(--theme-ui-brand)',
  'devui-brand-foil': 'var(--theme-brand-foil)',
  'devui-shape-icon-fill': 'var(--theme-shape-icon-fill)',
  'devui-shape-icon-fill-hover': 'var(--theme-shape-icon-fill-hover)',
  'devui-shape-icon-fill-disabled': 'var(--theme-shape-icon-fill-disabled)',
  'devui-dividing-line': 'var(--theme-dividing-line)',
  'devui-line': 'var(--theme-line-split)',
  'devui-disabled-line': 'var(--theme-disabled-line)',
  'devui-form-control-line': 'var(--theme-line-border)',
  'devui-form-control-line-hover': 'var(--theme-form-control-line-hover)',
  'devui-form-control-line-active': 'var(--theme-form-control-line-active)',
  'devui-primary': 'var(--theme-btn-primary)',
  'devui-primary-hover': 'var(--theme-btn-primary-hover)',
  'devui-primary-active': 'var(--theme-btn-primary-active)',
  'devui-primary-disabled': 'var(--theme-btn-primary-disabled)',
  'devui-btn-common-bg': 'var(--theme-btn-default)',
  'devui-btn-common-bg-hover': 'var(--theme-btn-default-hover)',
  'devui-disabled-bg': 'var(--theme-disabled-bg)',
  'devui-btn-common-border-color': 'var(--theme-btn-default-border)',
  'devui-btn-common-border-color-hover': 'var(--devui-btn-common-border-color-hover)',
  'devui-btn-common-border-disabled': 'var(--theme-btn-default-border-disabled)',
  'devui-gray-form-control-bg': 'var(--theme-table-header-bg)',
  'devui-gray-form-control-hover-bg': 'var(--theme-table-body-bg-hover)',
  'devui-link': 'var(--theme-link)',
  'devui-link-light': 'var(--theme-link-light)',
  'devui-link-disabled': 'var(--theme-link-disabled)',
  'devui-icon-hover-bg': 'var(--theme-icon-hover)',
  'devui-icon-active-bg': 'var(--theme-icon-active)',
  'devui-list-item-active-text': 'var(--theme-list-item-active-text)',
  'devui-list-item-active-bg': 'var(--theme-overlay-hover-bg)',
  'devui-list-item-selected-bg': 'var(--theme-list-item-selected-bg)',
  'devui-global-bg': 'var(--theme-global-bg)',
  'devui-connected-overlay-b': 'var(--theme-overlay-bg)',
  'devui-list-item-hover-text': 'var(--theme-list-item-hover-text)',
  'devui-list-item-hover-bg': 'var(--theme-overlay-hover-bg)',
  'devui-feedback-overlay-bg': 'var(--theme-feedback-overlay-bg)',
  'devui-danger-bg': 'var(--theme-danger-bg)',
  'devui-danger': 'var(--theme-danger)',
  'devui-danger-line': 'var(--theme-danger-line)',
  'devui-danger-text': 'var(--theme-danger-text)',
  'devui-contrast': 'var(--theme-contrast)',
  'devui-contrast-hover': 'var(--theme-contrast-hover)',
  'devui-contrast-active': 'var(--theme-contrast-active)',
  'devui-warning-bg': 'var(--theme-warning-bg)',
  'devui-warning': 'var(--theme-warning)',
  'devui-warning-line': 'var(--theme-warning-line)',
  'devui-warning-text': 'var(--theme-warning-text)',
  'devui-success-bg': 'var(--theme-success-bg)',
  'devui-success': 'var(--theme-success)',
  'devui-success-line': 'var(--theme-success-line)',
  'devui-success-text': 'var(--theme-success-text)',
  'devui-form-control-bg': 'var(--theme-input-bg)',
  'devui-icon-text': 'var(--theme-aide-text)',
  'devui-base-bg': 'var(--theme-default-bg)',
  'devui-fullscreen-overlay-bg': 'var(--theme-fullscreen-overlay-bg)',
  'devui-shadow': 'var(--theme-shadow)',
  'devui-connected-overlay-bg': 'var(--theme-default-bg)',
  'devui-glass-morphism-bg': 'rgba(245, 246, 248, 0.9)',
  'devui-global-bg-normal': '#ffffff',
  'devui-base-bg-dark': '#252b3a',
  'devui-brand-hover': '#7693f5',
  'devui-brand-active': '#526ecc',
  'devui-brand-active-focus': '#344899',
  'devui-text-weak': 'var(--theme-aide-text)',
  'devui-aide-text-hover': '#252b3a',
  'devui-aide-text-stress': '#575d6c',
  'devui-dark-text': '#252b3a',
  'devui-link-active': '#526ecc',
  'devui-link-light-active': '#beccfa',
  'devui-block': 'var(--theme-block)',
  'devui-area': 'var(--theme-area)',
  'devui-waiting': '#beccfa',
  'devui-initial': '#e9edfa',
  'devui-unavailable': '#f5f5f5',
  'devui-light-shadow': 'rgba(37, 43, 58, 0.12)',
  'devui-connected-overlay-shadow': 'rgba(37, 43, 58, 0.16)',
  'devui-feedback-overlay-shadow': 'rgba(37, 43, 58, 0.2)',
  'devui-icon-fill-active': '#252b3a',
  'devui-icon-fill-active-hover': '#252b3a',
  'devui-shape-icon-fill-active': '#babbc0',
  'devui-form-control-interactive-outline': 'rgba(94,124,224,0.08)',
  'devui-form-control-line-active-hover': '#344899',
  'devui-list-item-active-hover-bg': '#f2f5fc',
  'devui-list-item-strip-bg': '#f2f5fc',
  'devui-icon-fill-active-disabled': '#beccfa',
  'devui-label-bg': 'var(--theme-label-bg)',
  'devui-connected-overlay-line': '#526ecc',
  'devui-feedback-overlay-text': '#dfe1e6',
  'devui-embed-search-bg': '#f2f2f3',
  'devui-embed-search-bg-hover': '#eef0f5',
  'devui-float-block-shadow': 'rgba(94, 124, 224, 0.3)',
  'devui-highlight-overlay': 'rgba(255, 255, 255, 0.8)',
  'devui-range-item-hover-bg': 'var(--theme-range-item-hover-bg)', // 如：日历组件选中每个日期的hover背景色
  'devui-info-line': 'var(--theme-info-line)',
  'devui-info-bg': 'var(--theme-info-bg)',
  'devui-info': 'var(--theme-info)',
  'devui-primary-line': '#5e7ce0',
  'devui-primary-bg': '#f2f5fc',
  'devui-default-line': '#5e7ce0',
  'devui-default-bg': 'var(--theme-default-ui-bg)',
  'devui-menu-item': 'var(--theme-menu-item)',
  'devui-menu-item-sub': '#6C6C6C',
  'devui-menu-item-hover': 'var(--theme-menu-item-hover)',
  'devui-menu-disabled': '#919191',
  'devui-icon-active-color': '#ffffff',
  'devui-nav-expand-bg': '#fbfbfc',
  'devui-btn-common-color-hover': '#252B3A',
  'devui-btn-common-bg-active': '#BDBDBD',
  'devui-btn-common-color-active': '#252B3A',
  'devui-btn-common-border-color-active': 'transparent'
};

export const fontMap = {
  'devui-font-size': '14px',
  'devui-font-size-card-title': '16px',
  'devui-font-size-page-title': '16px',
  'devui-font-size-modal-title': '18px',
  'devui-font-size-price': '20px',
  'devui-font-size-data-overview': '24px',
  'devui-font-size-icon': '16px',
  'devui-font-size-sm': '12px',
  'devui-font-size-md': '14px',
  'devui-font-size-lg': '14px',
  'devui-font-content-weight': 'normal',
  'devui-line-height-base': '1.5'
};
export const zIndexMap = {
  'devui-z-index-dropdown': 1070
};
export const borderMap = {
  'devui-border-radius': '4px'
};

export const radiusMap = {
  'devui-border-radius-card': '4px'
};
